export default "__VITE_ASSET__CoeCSadn__"